// Vendor
import { createSelector } from '@ngrx/store';
// NgRx
import { getChartState } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart-base.selectors';
export const getSplitType = createSelector(getChartState, ({ splitType }) => splitType);
